import { render, staticRenderFns } from "./down.vue?vue&type=template&id=831cb906"
import script from "./down.vue?vue&type=script&lang=js"
export * from "./down.vue?vue&type=script&lang=js"
import style0 from "./down.vue?vue&type=style&index=0&id=831cb906&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports